import { render, staticRenderFns } from "./SubCategories.vue?vue&type=template&id=7dd6098a&"
import script from "./SubCategories.vue?vue&type=script&lang=js&"
export * from "./SubCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports